import { rankList } from "@/mocks/gossip";

const rankIcon = (i: number) =>
  i === 1 ? "bg-primary-500 text-background-50" : i === 2 ? "bg-accent-500 text-background-50" : "bg-secondary-200 text-secondary-700";

export default function Ranking() {
  return (
    <section id="ranking" className="scroll-mt-20 bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-3">
            <p className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-600">
              <i className="ri-medal-line text-sm" />
              热度走势
            </p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-900 md:text-3xl">本周热瓜 TOP 榜</h2>
            <p className="mt-2 text-sm text-foreground-600">按讨论热度实时更新，标题优先、不掺水分。</p>

            <ol className="mt-7 flex flex-col divide-y divide-background-200/70 rounded-lg border border-background-200/70 bg-background-50">
              {rankList.map((item, i) => (
                <li key={item.id}>
                  <a
                    href="#hot"
                    className="group flex items-center gap-4 p-4 transition-colors hover:bg-primary-50"
                  >
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${rankIcon(i)}`}
                    >
                      {i + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
                        {item.title}
                      </p>
                      <p className="mt-0.5 flex items-center gap-3 text-xs text-foreground-400">
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-fire-line text-primary-500" />
                          {item.heat}
                        </span>
                        <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-700">
                          {item.cat}
                        </span>
                      </p>
                    </div>
                    <span
                      className={`inline-flex shrink-0 items-center gap-1 text-xs font-semibold ${
                        item.up ? "text-accent-700" : "text-primary-600"
                      }`}
                    >
                      <i className={item.up ? "ri-arrow-up-line" : "ri-arrow-down-line"} />
                      {item.delta}
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          <aside className="lg:col-span-2">
            <div className="flex h-full flex-col justify-center rounded-lg border border-primary-200/60 bg-gradient-to-br from-primary-100/70 to-accent-100/50 p-6 md:p-7">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-line text-2xl" />
              </span>
              <h3 className="font-heading mt-4 text-xl font-bold leading-snug text-foreground-900">
                每天都有瓜，
                <br />
                但好瓜不该让你白跑一趟
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                榜单与卡片标题先说重点，点开内容直接对应，配图克制不夸张。
                吃瓜免费资源坚持“标题即内容”，帮你把有限的注意力留给真正值得吃的料。
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700">
                  <i className="ri-check-line text-accent-600" /> 每日更新
                </span>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700">
                  <i className="ri-check-line text-accent-600" /> 免登录畅享
                </span>
              </div>
              <a
                href="#hot"
                className="mt-6 inline-flex w-fit whitespace-nowrap items-center gap-2 rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
              >
                去榜单找瓜
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}